export default __webpack_public_path__ + "9f7c7b6af8b9e324bc82997a1102c41d.png";